import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a7d56654&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a7d56654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d56654",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7d56654')) {
      api.createRecord('a7d56654', component.options)
    } else {
      api.reload('a7d56654', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a7d56654&scoped=true&", function () {
      api.rerender('a7d56654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/operation-center/supplier-deduction-manage/page/index.vue"
export default component.exports